import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {VendorService} from 'src/app/custom/vendor/vendor.service';
import {GlobalModalChild, GlobalModalParent} from 'src/app/kanso-common/core/service';
import {Voucher} from '../vouchers-models/voucher';
import {vendorNode} from 'src/app/custom/vendor/vendor-model';
import {Observable} from 'rxjs';
import {debounceTime, map, startWith, switchMap} from 'rxjs/operators';
import {VendorTypes} from 'src/app/custom/housing-core/services/housing-models';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';

@Component({
  selector: 'app-vouchers-portout-wizard',
  templateUrl: './vouchers-portout-wizard.component.html',
  styleUrls: ['./vouchers-portout-wizard.component.scss'],
})
export class VouchersPortoutWizardComponent implements GlobalModalChild<any>, OnInit {
  @Input() voucher: Voucher;
  @Input() voucherForm: FormGroup;
  @Input() loggedInUser: string;
  @Input() voucherService;
  @Input() dialogRef;
  @Input() updateFunction;

  //editUnit: Unit;
  customAttributes: any[];

  vendorCtrl = new FormControl('');
  filteredVendors$: Observable<vendorNode[]>;
  globalModalParent: GlobalModalParent;
  selectedAuthorityId: string;
  spinnerCheck = false;
  overlay = false;

  constructor(public vendorService: VendorService) {}

  ngOnInit(): void {
    //create landlord stream
    this.filteredVendors$ = this.vendorCtrl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      switchMap((value: string) => this.vendorService.getVendorsV2(50, '', 'forward', value, VendorTypes.Housingauthority))
    );
  }

  onVendorSelected(event: MatAutocompleteSelectedEvent): void {
    const selectedVendor: vendorNode = event.option.value;

    this.selectedAuthorityId = selectedVendor.id;
  }

  vendorSelectDisplay(option: vendorNode): string {
    return option?.name || '';
  }

  save() {
    this.updateFunction(this.selectedAuthorityId);
    this.globalModalParent.closePopup();
  }

  cancel() {
    this.globalModalParent.closePopup();
  }
}
